var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloak({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 23.316c-27.177 0-58.578 5.75-79.525 17.967-20.688 13.774-43.22 60.756-43.22 60.756a333.206 333.206 0 0 0-9.16 16.376c-36.372 69.627-61.496 175.763-62.4 317.686 46.593 26.853 97.436 44.53 142.05 52.582-21.736-14.917-40.667-38.325-55.18-67.618 36.913-4.56 78.545-9.817 107.314-9.818 29.802 0 73.456 5.63 111.32 10.29-14.484 29.072-33.326 52.308-54.946 67.144 44.615-8.052 91.458-25.727 138.05-52.58-.903-141.923-26.027-248.06-62.4-317.686a331.068 331.068 0 0 0-9.16-16.375v-.003s-22.53-46.98-43.22-60.754c-23.52-11.95-52.347-17.967-79.524-17.967zm-.045 16.22c30.187 3.09 57.525 4.198 76.307 24.67-18.46 21.81-45.975 49.5-76.29 49.503-30.302.002-66.432-30.935-76.27-49.468 17.72-19.566 53.18-24.537 76.253-24.707zM170.57 80c5.43 12.588 52.522 49.167 85.375 49.25C289.09 129.333 336 91.16 342.32 80c0 0 12.28 18.68 18.594 31.057l4.55 10.906c20.518 45.148 32.614 92.753 32.614 158.1 0 45.65-8.408 88.144-22.873 123.724-32.45-4.387-73.958-7.39-119.205-7.39-43.513 0-83.54 2.78-115.408 6.896-14.34-35.48-22.67-77.792-22.67-123.23 0-65.347 8.096-112.952 28.613-158.1l4.55-10.906C157.378 98.725 170.57 80 170.57 80z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloak);
export default __webpack_public_path__ + "static/media/cloak.c632719fe396763abde334dd621127e5.svg";
export { ForwardRef as ReactComponent };